<template>
  <div class="product-detail">
    <!-- 正常显示产品内容 -->
    <div v-if="item" class="container content">
      <!-- 返回列表 -->
      <div class="back" @click="$router.push('/products')">
        <i class="el-icon-arrow-left"></i> 返回产品列表
      </div>

      <!-- 上半部分：左图右简介 -->
      <div class="top">
        <div class="cover">
          <img v-if="item.cover" :src="item.cover" :alt="item.name">
          <div v-else class="img-placeholder">暂无图片</div>
        </div>
        <div class="info">
          <h1 class="name">{{ item.name }}</h1>
          <div class="price">{{ priceText(item.price) }}</div>
          <p class="summary">{{ item.summary || '暂无简介' }}</p>
        </div>
      </div>

      <!-- 下半部分：详细介绍（富文本 HTML） -->
      <div class="detail-block">
        <h3 class="detail-title">产品详情</h3>
        <div class="article" v-html="item.description || '暂无详细介绍'"></div>
      </div>
    </div>

    <!-- 加载中 -->
    <div v-else-if="loading" class="container content">
      <el-skeleton :rows="8" animated />
    </div>

    <!-- 内容不存在（已删除或已隐藏） -->
    <div v-else class="container content">
      <el-empty description="该产品不存在或已被隐藏">
        <el-button type="primary" @click="$router.push('/products')">返回产品列表</el-button>
      </el-empty>
    </div>
  </div>
</template>

<script>
import { getProductDetail } from '../api'

export default {
  name: 'ProductDetail',
  data() {
    return {
      loading: true,
      item: null   // 产品详情，加载失败或不存在时保持 null
    }
  },
  created() {
    this.fetchDetail()
  },
  methods: {
    async fetchDetail() {
      this.loading = true
      try {
        const res = await getProductDetail(this.$route.params.id)
        this.item = res.data
        document.title = this.item.name + ' - 示例科技'
      } catch (e) {
        this.item = null
      } finally {
        this.loading = false
      }
    },
    priceText(price) {
      if (price === null || price === undefined) return '面议'
      return '￥' + Number(price).toFixed(2)
    }
  }
}
</script>

<style scoped>
.content { padding: 32px 0 60px; }

.back {
  display: inline-block;
  margin-bottom: 20px;
  color: #909399;
  font-size: 14px;
  cursor: pointer;
}
.back:hover { color: #1677ff; }

/* 左图右信息：窄屏时自动换行成上下结构 */
.top {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid #ebeef5;
}
.cover {
  flex: 0 0 420px;
  max-width: 100%;
  height: 340px;
  border-radius: 8px;
  overflow: hidden;
  background: #eef0f3;
}
.cover img { width: 100%; height: 100%; object-fit: cover; }
.info { flex: 1; min-width: 260px; }
.name { margin: 0 0 16px; font-size: 28px; color: #1f2d3d; }
.price { margin-bottom: 20px; color: #f56c6c; font-size: 26px; font-weight: 600; }
.summary { margin: 0; font-size: 15px; color: #606266; line-height: 1.8; }

.detail-block { margin-top: 32px; }
.detail-title {
  position: relative;
  margin: 0 0 20px;
  padding-left: 14px;
  font-size: 20px;
  color: #1f2d3d;
}
.detail-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 3px;
  bottom: 3px;
  width: 4px;
  border-radius: 2px;
  background: #1677ff;
}

/* 详细介绍排版 */
.article {
  font-size: 16px;
  line-height: 1.9;
  color: #303133;
  word-break: break-word;
}
.article >>> img { max-width: 100%; height: auto; }
.article >>> p { margin: 0 0 16px; }
.article >>> h1, .article >>> h2, .article >>> h3 { margin: 24px 0 12px; }
</style>
